import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class ValidatorService {

  constructor() { }

  subRequired(form: string, parent: string, expectedParent: any | any[] = 1) {
    return (formGroup: FormGroup) => {
      const formControl = formGroup.controls[form];
      const parentControl = formGroup.controls[parent];

      if (formControl.errors && !formControl.errors['required']) {
        return;
      }
      // set error on matchingControl if validation fails
      if (typeof (expectedParent) == 'object' && expectedParent.includes(parentControl.value) && !formControl.value) {
        formControl.setErrors({ required: true });
      } else if (typeof (expectedParent) != 'object' && parentControl.value == expectedParent && !formControl.value) {
        formControl.setErrors({ required: true });
      } else {
        formControl.setErrors(null);
      }
    }
  }

  alMenosUnFrom(checks: string[]) {
    return (formGroup: FormGroup) => {
      let all = false;
      checks.forEach(element => {
        const check = formGroup.controls[element];
        all = all || check.value;
      });
      if (!all) {
        formGroup.controls[checks[0]].setErrors({ alMenosUnSelect: true });
      } else {
        formGroup.controls[checks[0]].setErrors(null);
      }
    }
  }

  rangoInvalido(start: string, end: string) {
    return (formGroup: FormGroup) => {
      const hora_inicio = formGroup.controls[start];
      const hora_fin = formGroup.controls[end];

      if (hora_fin.errors && !hora_fin.errors['rangoInvalido']) {
        return;
      }
      // set error on matchingControl if validation fails
      if (hora_inicio.value > hora_fin.value) {
        hora_fin.setErrors({ rangoInvalido: true });
      } else {
        hora_fin.setErrors(null);
      }
    }
  }

  esMultiploDe(form: string, multiplo: number) {
    return (formGroup: FormGroup) => {
      const formControl = formGroup.controls[form];

      if (formControl.errors && !formControl.errors['required']) {
        return;
      }
      // set error on matchingControl if validation fails
      if (formControl.value % multiplo !== 0) {
        formControl.setErrors({ esMultiploDe: true });
      } else {
        formControl.setErrors(null);
      }
    }
  }
}
